import { Button } from './Button'
import styles from './Pagination.module.css'

export interface PaginationProps {
  readonly page: number
  readonly totalPages: number
  readonly totalRecords: number
  readonly onPage: (page: number) => void
  readonly labels: {
    readonly region: string
    readonly previous: string
    readonly next: string
    /** Already interpolated by the caller, e.g. "Page 2 of 7 · 340 records". */
    readonly summary: string
  }
}

/**
 * `<nav>` with a label, because a screen-reader user needs to find these
 * controls without reading the whole table first. The summary is a live region
 * so that moving pages announces where you landed — otherwise the only
 * feedback is the table silently changing beneath you.
 */
export function Pagination({ page, totalPages, totalRecords, onPage, labels }: PaginationProps) {
  if (totalRecords === 0) return null
  return (
    <nav className={styles.pagination} aria-label={labels.region}>
      <p aria-live="polite">{labels.summary}</p>
      <div className={styles.controls}>
        <Button size="sm" variant="secondary" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          {labels.previous}
        </Button>
        <span className={styles.page} aria-hidden="true">
          {page} / {Math.max(totalPages, 1)}
        </span>
        <Button size="sm" variant="secondary" disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
          {labels.next}
        </Button>
      </div>
    </nav>
  )
}
